import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'modal-auth',
  templateUrl: './modal-auth.component.html',
  styleUrls: ['./modal-auth.component.css']
})
export class ModalAuthComponent implements OnInit {

  @Input() img: string;

  constructor() { }

  ngOnInit(): void {
  }

}
